export const NOT_FORWARD_PROPS = [
  'fontSize',
  'hasChildren',
  'hasCoordinates',
  'history',
  'isOpen',
  'isTransparent',
  'location',
  'match',
  'padding',
  'position',
  'size',
  'staticContext',
  'variant',
  'variantType',
  'withUnmountToggle',
  'fullWidth',
  'verified'
];
